// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/(auth)/_layout.tsx"); } },
  "./(auth)/login.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/(auth)/login.tsx"); } },
  "./(auth)/signup.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/(auth)/signup.tsx"); } },
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/chat.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/(tabs)/chat.tsx"); } },
  "./(tabs)/design.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/(tabs)/design.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/(tabs)/index.tsx"); } },
  "./(tabs)/profile.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/(tabs)/profile.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/pentarchy-club/pentarchy-club/client/app/_layout.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;